export default __webpack_public_path__ + "assets/logos-partners/fortinet/5bd98959a0c6bd83cccc591707834692.png";